import { Close } from '@watersport/ui-react-icons'
import React from 'react'

export interface DrawInstructionProps {
  onClose: () => void
}

const DrawInstruction: React.FC<DrawInstructionProps> = ({ onClose }) => {
  return (
    <div className="absolute inset-0 z-10">
      <div className="absolute top-[175px] left-1/2 transform -translate-x-1/2 w-full px-4">
        <div className="bg-blue-900 text-white text-lg p-4 rounded-[18px] shadow-lg flex items-center justify-center gap-3">
          <div className="flex flex-col items-start justify-center flex-1">
            <p className="text-sm">{'Draw by clicking to connect points,'}</p>
            <p className="text-sm">{'or click and drag to draw freely.'}</p>
          </div>
          <div className="flex items-center justify-center" onClick={onClose}>
            <Close width="24" height="24" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DrawInstruction
